import TwoFA from "./TwoFa";
import UpdateUserLoggedInPassword from "./UpdateLoggedInUserPassword";

const Security = () => {
  return (
    <div className="main-container">
      <div className="atendoo-card">
        <h6 className="subtitle mb-3">Seguridad</h6>
        <p>Habilita el doble factor de autenticación para dar mayor seguridad a tu cuenta.</p>
        <br />
        <TwoFA />
        <p>Modificar contraseña.</p>
        <br />
        <UpdateUserLoggedInPassword />
      </div>
    </div>
  )
}

export default Security;